import React from "react";

const PersonalCard = ({ even, summary, name, personsTitle }) => {
  return (
    <div className={`items-center  shadow sm:flex bg-primary text-black `}>
      <div className="p-5">
        <h3 className="text-xl md:text-2xl lg:text-3xl font-bold tracking-tight">
          {name}
        </h3>
        <span className={` text-gray-700 lg:text-xl `}>{personsTitle}</span>
        <p className="mt-3 mb-4 f ">{summary}</p>
      </div>
    </div>
  );
};

export default PersonalCard;
